import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1>404</h1>
            <h2>The page you are looking for is not available</h2>
        </div>
    );
};

export default NotFound;